import { Pipe, PipeTransform } from "@angular/core";
import { DateFormatOptions } from "@progress/kendo-angular-intl";
import { I18nService } from "../services";

@Pipe({
    name: "i18nDate",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class I18nDatePipe implements PipeTransform {
  constructor(private translate: I18nService) {}

  public transform(value: Date, format?: string | DateFormatOptions): unknown {
    return this.translate.formatDate(value, format);
  }
}

@Pipe({
    name: "asDate",
    pure: false // required to update the value when the promise is resolved
    ,
    standalone: false
})
export class AsDatePipe implements PipeTransform {
  public transform(value: unknown): Date {
    if (!value) {
      return null;
    }
    if (value instanceof Date) {
      return value as Date;
    }

    return new Date(value as string);
  }
}
